import React, { Component } from 'react';
import { connect } from 'react-redux';
import InputMask from 'react-input-mask';
import { doShowModal } from '../../../actions/ui';
import classNames from 'classnames';
import './index.css';
import { createLogger } from '../../../services/logger';
import { getCurrentCardBrand } from '../../../selectors/brand';

const logger = createLogger('api/client');

class FormGroup extends Component {
  state = {
    isFocused: false,
  };

  onFocus = () => {
    this.setState({ isFocused: true });
  };

  onBlur = () => {
    this.setState({ isFocused: false });
  };

  onCvvClick = e => {
    e.preventDefault();
    this.props.onShowModal(e.target.dataset.target);
  };

  validateFieldFill = (value, disableValidation) => {
    try {

      if(disableValidation) {
        return true;
      }

      const trimMask = (this.props.mask).replace(/\s/g,'').length;
      let trimValue = (this.props.value).replace(/\s/g,'').length;

      if (trimValue === trimMask) {
        return true;
      } else if (value.match(/[0-9]/g)) {
        return false;
      }

    } catch (e) {
      logger.error("Erro ao validor campo:" + e);
    }
  };

  render() {
    const {
      id,
      name,
      placeholder,
      onChangeValue,
      value,
      mask,
      type,
      readOnly,
      autoComplete,
      disableValidation = false,
      error,
      maskChar = " ",
    } = this.props;
    const isFilled = this.state.isFocused || value;
    const fieldClasses = classNames({
      'content-box': true,
      'form-group': true,
      'form-group--filled': isFilled && !readOnly && !error,
      'form-group--success': this.validateFieldFill(this.props.value, disableValidation),
      'form-group--error': (!this.validateFieldFill(this.props.value, disableValidation) && isFilled) || error,
      'form-group--onfocus': this.state.isFocused && !error,
    });
    const labelClasses = classNames({
      'form-group__label': true,
      'form-group__label--filled': isFilled && !readOnly,
      'form-group__label--read-only': readOnly,
      'form-group__label--error': error,
    });
    const inputClasses = classNames({
      'form-group__input': true,
      'form-group__input--filled': isFilled && !readOnly,
    });

    if (mask) {
      return (
        <div className={fieldClasses}>
          <label className={labelClasses} htmlFor={id}>
            {placeholder}
          </label>
          <InputMask
            className={inputClasses}
            id={id}
            name={name}
            type={type}
            readOnly={readOnly}
            mask={mask}
            formatChars={{ '9': '[0-9]', '?': '[0-9]' }}
            maskChar={maskChar}
            onChange={e => {
              const value = onChangeValue !== null ? onChangeValue(e) : null;
              return value
            }}
            value={value || ''}
            onFocus={() => {
              this.onFocus();
              this.props.onFocus && this.props.onFocus();
            }}
            onBlur={() => {
              this.onBlur();
              this.props.onBlur && this.props.onBlur();
            }}
            autoComplete={autoComplete}
          />
          {id === 'field-validator' && this.validateFieldFill(this.props.value) ? (
            <div className="form-group--image"></div>
          ) : null}
        </div>
      );
    } else {
      return (
        <div className={fieldClasses}>
          <label className={labelClasses} htmlFor={id}>
            {placeholder}
          </label>
          <input
            className={inputClasses}
            id={id}
            name={name}
            type={type}
            readOnly={readOnly}
            onChange={onChangeValue}
            value={value || ''}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            autoComplete="off"
          />
        </div>
      );
    }
  }
}

const mapStateToProps = state => ({
  currentCardBrand: getCurrentCardBrand(state)
});

const mapDispatchToProps = dispatch => ({
  onShowModal: target => dispatch(doShowModal(target)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FormGroup);
